// extracted by mini-css-extract-plugin
module.exports = {"main":"LoginPage_main__EKdF3","button":"LoginPage_button__QN7tV","message":"LoginPage_message__2VX3y","error":"LoginPage_error__NOlyT"};